import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FaqSection from './components/FaqSection';
import SeoHead from './seo/SeoHead';
import { PAGES, BUSINESS } from './seo/businessConfig';
import { buildHomeGraph } from './seo/schema';
import './App.css';
import { Link } from 'react-router-dom';
import image1 from './images/DSC06004.jpg';
import image2 from './images/DSC06003.jpg';
import image3 from './images/DSC05994.jpg';
import image4 from './images/DSC06061.jpg';
import image5 from './images/DSC06062.jpg';
import image6 from './images/DSC06061.jpg';
import image7 from './images/DSC06034.jpg';
import image8 from './images/DSC06029.jpg';
import image9 from './images/DSC06016.jpg';
import scrolldown from './images/mouse-cursor.png';

function App() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const page = PAGES.home;

  return (
    <div className="relative">
      <SeoHead
        title={page.title}
        description={page.description}
        keywords={page.keywords}
        path={page.path}
        jsonLd={buildHomeGraph()}
      />
      <Navbar />

      <header className="tlo w-full h-screen relative flex items-center justify-center">
        <div className="sr-only">
          <h1>Agroturystyka Zacisze Czarna Owca — noclegi w Brzeżance koło Strzyżowa</h1>
        </div>
        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce w-16 h-16 md:w-20 md:h-20">
          <img src={scrolldown} alt="Przejdź niżej do oferty agroturystyki Czarna Owca" className="w-full h-full object-contain" />
        </div>
      </header>

      <main className="bg-primary-olive h-fit pb-20">
        <section className="flex flex-col xl:flex-row max-w-7xl mx-auto">
          <div className="w-full xl:w-1/2 text-primary pt-16 md:pt-32 px-6 md:px-12 lg:px-20">
            <p className="text-base md:text-xl font-thin mb-2 md:mb-4 uppercase">
              Witamy w Zaciszu Czarna Owca · Brzeżanka / Strzyżów
            </p>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-extrabold mb-6 leading-tight">
              Komfort, Relaks <br /> i Atrakcje
            </h2>
            <p className="text-base md:text-lg w-full md:w-4/5 leading-relaxed">
              Agroturystyka Zacisze Czarna Owca w Brzeżance koło Strzyżowa to idealne miejsce
              na wypoczynek z dala od zgiełku — z basenem, sauną, jacuzzi i kortem tenisowym.
              Leżymy około 5 km od Strzyżowa, w dogodnej odległości od Rzeszowa, w okolicach
              Czarnorzecko-Strzyżowskiego Parku Krajobrazowego.
            </p>
            <div className="text-primary-bright mt-10 flex flex-col sm:flex-row gap-4">
              <Link to="/nasza_historia">
                <button className="bg-primary hover:bg-primary-dark transition-colors p-4 rounded-sm w-full sm:w-auto sm:px-10 font-bold tracking-wide">
                  NASZA HISTORIA
                </button>
              </Link>
              <Link to="/kontakt">
                <button className="border-2 border-primary text-primary hover:bg-primary hover:text-primary-bright transition-colors p-4 rounded-sm w-full sm:w-auto sm:px-10 font-bold tracking-wide">
                  REZERWUJ · {BUSINESS.telephoneDisplay}
                </button>
              </Link>
            </div>
          </div>

          <div className="hidden xl:block w-1/2 relative min-h-[600px] mt-20">
            <img src={image1} alt="Teren agroturystyki Zacisze Czarna Owca w Brzeżance — leżaki" className="w-64 h-40 absolute bottom-40 left-12 rounded-sm shadow-lg object-cover" />
            <img src={image2} alt="Basen zewnętrzny w pensjonacie Czarna Owca koło Strzyżowa" className="w-72 h-48 absolute left-0 top-24 rounded-sm shadow-lg object-cover z-10" />
            <img src={image3} alt="Ławki na terenie Zacisze Czarna Owca Podkarpacie" className="w-48 h-32 absolute left-72 bottom-80 rounded-sm shadow-lg object-cover" />
            <img src={image4} alt="Sauna w agroturystyce Zacisze Czarna Owca" className="w-56 h-40 absolute bottom-40 left-72 rounded-sm shadow-lg object-cover z-20" />
          </div>
        </section>

        <section className="max-w-4xl mx-auto mt-16 md:mt-24 px-6 md:px-12 text-primary" aria-labelledby="local-seo-heading">
          <h2 id="local-seo-heading" className="text-2xl md:text-4xl font-bold mb-4">
            Noclegi agroturystyczne koło Strzyżowa i Rzeszowa
          </h2>
          <p className="text-base md:text-lg leading-relaxed mb-4">
            Szukasz spokojnego pensjonatu na Podkarpaciu? Zacisze Czarna Owca łączy klimat
            agroturystyki z infrastrukturą rekreacyjną: basenem, sauną, jacuzzi, kortem tenisowym
            oraz salą balową na wesela i imprezy. Adres: {BUSINESS.address.streetAddress},{' '}
            {BUSINESS.address.postalCode} {BUSINESS.address.cityForSearch}.
          </p>
          <p className="text-base md:text-lg leading-relaxed">
            Obiekt sprawdza się na rodzinny urlop, wypoczynek we dwoje, imprezy integracyjne
            oraz wieczory panieńskie i kawalerskie z możliwością wynajęcia całego domku.
          </p>
        </section>

        <section className="flex flex-col items-center mt-20 md:mt-32 text-primary px-4">
          <h2 className="text-lg md:text-xl font-thin uppercase mb-8">Nasze atrakcje</h2>
          <div className="flex flex-col w-full max-w-4xl mx-auto px-4 sm:px-10">
            {[
              { num: '01', name: 'Basen' },
              { num: '02', name: 'Sauna' },
              { num: '03', name: 'Kort tenisowy' },
              { num: '04', name: 'Jacuzzi' },
              { num: '05', name: 'Sala balowa' },
              { num: '06', name: 'Sala gier (bilard, tenis, rzutki, piłkarzyki)' },
              { num: 'oraz', name: 'Mnóstwo przestrzeni' },
            ].map((item, index) => (
              <div key={index} className="flex items-center my-4 md:my-6">
                <span className="text-lg md:text-2xl font-thin w-20 text-right pr-6">{item.num}</span>
                <span className="font-bold text-3xl sm:text-4xl md:text-5xl tracking-widest">{item.name}</span>
              </div>
            ))}
          </div>
        </section>

        <section className="flex flex-wrap justify-center w-full mt-24 md:mt-40 gap-2 md:gap-4 px-2 md:px-4">
          <img src={image5} alt="Dekoracja wozu konnego — Zacisze Czarna Owca Brzeżanka" className="w-[48%] md:w-[18%] aspect-square object-cover rounded-sm shadow-md hover:scale-105 transition-transform" />
          <img src={image6} alt="Basen zewnętrzny agroturystyka Strzyżów" className="w-[48%] md:w-[18%] aspect-square object-cover rounded-sm shadow-md hover:scale-105 transition-transform" />
          <img src={image7} alt="Sauna w pensjonacie Czarna Owca" className="w-[48%] md:w-[18%] aspect-square object-cover rounded-sm shadow-md hover:scale-105 transition-transform" />
          <img src={image8} alt="Napis LOVE — wesela i imprezy Czarna Owca" className="w-[48%] md:w-[18%] aspect-square object-cover rounded-sm shadow-md hover:scale-105 transition-transform" />
          <img src={image9} alt="Stół bilardowy — sala gier Czarna Owca" className="w-[48%] md:w-[18%] aspect-square object-cover rounded-sm shadow-md hover:scale-105 transition-transform" />
        </section>

        <FaqSection className="mt-24 md:mt-32" />

        <div className="w-full overflow-hidden flex justify-center mt-20 md:mt-32">
          <p className="text-primary text-[60px] sm:text-[100px] lg:text-[200px] xl:text-[250px] tracking-wider font-bold text-center leading-none opacity-80 whitespace-nowrap">
            CZARNA OWCA
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default App;
